import {
  type DataTestId,
  type StylingProps,
} from '@dynatrace/strato-components/core';

/**
 * @public
 */
export type SelectV2FilterProps = StylingProps &
  DataTestId & {
    /**
     * Flag indicating if the client-side filtering should be disabled or not.
     * @defaultValue false
     **/
    disableFiltering?: boolean;
    /** Defines the default filter string. */
    defaultValue?: string;
    /** Defines the filter string value. */
    value?: string;
    /** The callback is triggered when the filterValue changes. */
    onChange?: (filterValue: string) => void;
  };

/**
 * @public
 */
export function SelectV2Filter(props: SelectV2FilterProps): null {
  return null;
}
